/* eslint-disable no-param-reassign */

import Reqs from '@/services/api/layout/layout';
import router from '@/router/routes'
import loginApi from '@/services/api/login/login';
import {
  Storage,
  Cookie
} from "@/utils/utils";
import Router from '@/router/index';
import store from '@/store';
import Vue from 'vue';
import qs from 'qs';
let getUserInfoState = () => {
  return Storage.get('wfUserInfo') ? Storage.get('wfUserInfo') : {}
}
export default {
  state: {
    isCollapse: true,
    userInfo: getUserInfoState(),
    menu: [],
    isLock: Storage.get('isLock') || false,
    lockPasswd: Storage.get('lockPasswd') || '',
    userType: '',
    isRouterShowView: true,
    roleMenuList: [],
    orgList: [],
    userInfoStatus: 0,
    menuTagTxt: Storage.getSession('menuTagTxt') || [],
    scrollTop: 0,
    showHeader: true,
    userTimer: null,
    pickerOptions: {
      disabledDate(time) {
        let curDate = (new Date()).getTime();
        let three = 90 * 24 * 3600 * 1000;
        let one = 1 * 24 * 3600 * 1000;
        let threeMonths = curDate - three;
        return time.getTime() > Date.now() - one || time.getTime() < threeMonths;;
      },
      shortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date(new Date().setDate(new Date().getDate() - 1));
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date(new Date().setDate(new Date().getDate() - 1));
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date(new Date().setDate(new Date().getDate() - 1));
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
    },
    shortcuts: {
      shortcuts: [{
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    },
  },
  mutations: {
    opCollapse(state, isColl) {
      if (isColl === 'opposite') {
        state.isCollapse = !state.isCollapse;
      } else {
        state.isCollapse = isColl;
      }
    },
    SET_SHOWHEADER: (state, data) => {
      state.showHeader = data
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_TABLEHEAD: (state, data) => {
      state[data.key] = data.dataList
      Storage.setSession(`${data.key}`, data.dataList);
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
    },
    SET_LOCK: (state, action) => {
      state.isLock = true;
      Storage.set('isLock', state.isLock)
    },
    SET_LOCK_PASSWD: (state, lockPasswd) => {
      state.lockPasswd = lockPasswd;
      Storage.set('lockPasswd', state.lockPasswd)
    },
    CLEAR_LOCK: (state, action) => {
      state.isLock = false;
      state.lockPasswd = '';
      Storage.remove('lockPasswd');
      Storage.remove('isLock');
    },
    SETROLE_LIST: (state, data) => {
      state.roleMenuList = data
    },
    SET_USERONFOSTATUS: (state, data) => {
      state.userInfoStatus = data
    },
    SET_MENUTXT: (state, data) => {
      let _menuList = Storage.getSession('menuTagTxt')
      let idx = _menuList.findIndex((res) => res.path == data.path)
      // console.log('state.menuTagTxt', data, state.menuTagTxt, idx)
      if (idx > -1) {
        _menuList = _menuList.slice(0, idx + 1)
      } else {
        _menuList.push(data)
      }
      Storage.setSession('menuTagTxt', _menuList)
      state.menuTagTxt = _menuList
    },
    SET_MENUTXTINIT: (state, data) => {
      state.menuTagTxt = JSON.parse(JSON.stringify(data))
      Storage.setSession('menuTagTxt', state.menuTagTxt)
    },
    REPLACE_MENU: (state, data) => {
      let _menuList = Storage.getSession('menuTagTxt')
      _menuList.splice(_menuList.length - 1, 1, data)

      Storage.setSession('menuTagTxt', _menuList)
      state.menuTagTxt = _menuList
    }
  },
  getters: {
    userInfo: (state) => {
      return state.userInfo
    },
    isBoss: (state) => {
      let pos = Vue.prototype.$permission('所有数据')
      return pos
    }
  },
  actions: {
    async userIsTimeout({
      state,
      dispatch
    }) {
      let expiresTime = qs.parse(state.userInfo.user_avatar).Expires
      let now = new Date().getTime() / 1000
      if (now > expiresTime) {
        await dispatch('setUserInfo')
        setTimeout(() => {
          dispatch('userIsTimeout')
        }, 1800000);
      }
    },
    tableInit({
      commit,
      state
    }, params) {
      if (!Storage.getSession(params)) {
        Storage.setSession(params, state[params]);
      } else {
        state[params] = Storage.getSession(params);
      }
    },
    clearLoginOutData({
      commit,
      state,
      dispatch
    }, params) {
      Storage.remove("wfUserInfo")
      Storage.clearSession()
      store.state['tags/tags'].tagList = []
      store.state['tags/tags'].tag = {}
      commit('SET_USERINFO', {})
    },
    login({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise(async (resolve, reject) => {
        Reqs.login(params).then(async res => {
          Storage.set('wfUserInfo', res)
          await dispatch('setUserInfo', res)
          // dispatch('userIsTimeout')
          resolve(res)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    loginOut({
      commit,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        // Reqs.loginOut(params).then(() => {
        dispatch('clearLoginOutData')
        Router.push({
          path: '/login'
        })
        Router.go(0)
        // })
      })
    },
    getMenu({
      commit,
      state
    }, params) {
      return new Promise((resolve, reject) => {
        commit('SETROLE_LIST', router[0].children)
        resolve()
      })
    },
    ChangePass({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        const obj = {};
        const {
          againPass,
          newPass
        } = params;
        obj.password = newPass;
        obj.password2 = againPass;
        Reqs.changePass(obj)
          .then(() => {
            // commit
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setUserInfo({
      commit,
      action
    }, params) {
      return new Promise((resolve, reject) => {
        loginApi.getUserInfo().then(res => {
          let userInfo = {}
          if (!params) {
            let userMsg = Storage.get('wfUserInfo')
            userInfo = { ...Object.assign({}, userMsg, res) }
          } else {
            userInfo = { ...Object.assign({}, params, res) }
          }
          Storage.set('wfUserInfo', userInfo)
          commit('SET_USERINFO', userInfo)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetMenuListPage({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        Reqs.getMenuListPage(params)
          .then((res) => {
            const checkList = (res) => {
              for (let i = 0; i < res.length; i++) {
                res[i].label = res[i].menuName;
                res[i].value = res[i].menuUrl;
                if (res[i].children) {
                  checkList(res[i].children);
                }
              }
            };
            checkList(res);
            commit('SET_MENU', res.reverse());
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    AddMenu({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        const nowParams = {
          parentId: params.parentId,
          menuName: params.menuName,
          menuType: params.menuType,
          sortOrder: params.sortOrder,
          menuUrl: params.menuUrl,
          icon: params.icon,
          perms: params.perms,
        };
        Reqs.addMenu(nowParams)
          .then((res) => {
            // commit
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    EditMenu({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        const nowParams = {
          id: params.id,
          parentId: params.parentId,
          menuName: params.menuName,
          menuType: params.menuType,
          sortOrder: params.sortOrder,
          menuUrl: params.menuUrl,
          icon: params.icon,
          perms: params.perms,
        };
        Reqs.editMenu(nowParams)
          .then((res) => {
            // commit
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    DeleteMenu({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        const nowParams = {
          id: params.id,
          parentId: params.parentId,
          menuName: params.menuName,
          menuType: params.menuType,
          sortOrder: params.sortOrder,
          menuUrl: params.menuUrl,
          icon: params.icon,
          perms: params.perms,
        };
        Reqs.deleteMenu(nowParams)
          .then((res) => {
            // commit
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
